import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from '@angular/core';
import { apiUrlInterceptor } from 'app/core/auth/api-url.interceptor';
import { authInterceptor } from 'app/core/auth/auth.interceptor';
import { AuthService } from 'app/core/auth/auth.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([apiUrlInterceptor, authInterceptor])),
        provideEnvironmentInitializer(() => inject(AuthService)),
    ];
};
